<template>
	<div class="bottom">
		<div class="line" style="background-color: #ffffff;">
			<svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
				<defs><path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" /></defs>
				<g class="parallax">
					<use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(29, 165, 235, 0.4)" />
					<use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(32, 202, 207, 0.5)" />
					<use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(79, 53, 237, 0.2)" />
					<use xlink:href="#gentle-wave" x="48" y="7" fill="rgba(37, 59, 85, 1)" />
				</g>
			</svg>
		</div>
		<div class="main animate__animated animate__fadeIn">
			<div class="left">
				<div class="tit">About Us</div>
				<div class="linkCon">
					<a class="link" href="about.html#/intro">Company Profile</a>
					<a class="link" href="about.html#/org/frame">Organizational Structure</a>
					<a class="link" href="about.html#/business">Main Business</a>
					<a class="link" href="about.html#/honor">Qualifications and Honors</a>
					<a class="link" href="about.html#/culture/slogan">Corporate Culture</a>
					<a class="link" href="about.html#/branch/singapore">Affiliated Agency</a>
				</div>
				<div class="tit">Performance Presentation</div>
				<div class="linkCon">
					<a class="link" href="perform.html#/oil">Offshore Oil and Gas Projects</a>
					<a class="link" href="perform.html#/wind">Offshore Wind Power Project</a>
					<a class="link" href="perform.html#/cable">Cable Laying and Maintenance</a>
					<a class="link" href="perform.html#/lease">Vessel Leasing Business</a>
				</div>
				<div class="tit">Company Resources</div>
				<div class="linkCon">
					<a class="link" href="resource.html#/ship">Vessel Resources</a>
					<a class="link" href="resource.html#/equip">Equipment Resources</a>
				</div>
				<div class="tit">News and Information</div>
				<div class="linkCon">
					<a class="link" href="news.html">Business Movement</a>
				</div>
			</div>
			<div class="right">
				<div class="logoImgCon">
					<el-image class="logoImg" :src="baseImgUrl + logo_light"></el-image>
				</div>
				<div>
					<el-image class="qrImg" :src="baseImgUrl + compQrCode"></el-image>
				</div>
				<div class="websites">
					<el-select placeholder="Blogroll" value="" v-model="selectValue" @change="routerTo">
						<el-option v-for="(item,index) in websiteList" :key="index" :label="item.webLabelEn" :value="item.website"></el-option>
					</el-select>
				</div>
			</div>
			<div class="leftLeft">
				<div class="logoImgCon">
					<el-image class="logoImg" :src="baseImgUrl + logo_light"></el-image>
				</div>
				<div class="leftLeftItem">Address：{{contactVo.address}}</div>
				<div class="leftLeftItem">Email：{{contactVo.mail}}</div>
				<div class="leftLeftItem">Tel：{{contactVo.tel}}</div>
			</div>
			<div class="rightRight">
				<div>
					<el-image class="qrImg" :src="baseImgUrl + compQrCode"></el-image>
				</div>
			</div>
		</div>
		<div class="copy">Copyright © {{curYear}} DS Global Offshore Engineering (Tianjin) Co., Ltd</div>
	</div>
</template>

<script>
export default {
	name: "Bottom",
	data() {
		return{
			baseImgUrl: process.env.VUE_APP_IMGURL,
			selectValue: '',
			websiteList: [],
			logo_light: 'assets/bottom/logo_light_en.png',
			compQrCode: '',
			curYear: '',
			contactVo: { address:'', tel:'', mail:'', web:'', banner:'', officialQr:'', webQr: '' }
		}
	},
	mounted() {
		let curDate = new Date();
		this.curYear = curDate.getFullYear();

		this.$api.get('other/getWebsites').then(res => {
			this.websiteList = res;
		});

		this.$api.get('contact/get').then(res => {
			this.contactVo = res;
		});

		this.$api.get('contact/getCompQrCode').then(res => {
			this.compQrCode = res;
		});
	},
	methods: {
		routerTo(val){
			location.href=val;
		}
	}
}
</script>

<style scoped>
	.bottom{ margin-top: 45px; }
	.bottom, .el-select-dropdown__item{ font-family: 'SiYuan-ExtraLight', sans-serif; }

	.copy{ animation: fadeInUp; animation-duration: 1.2s; }
	.left{ animation: fadeInLeft; animation-duration: 1.2s; }
	.right{ animation: fadeInRight; animation-duration: 1.2s; }

	a{ color: #959595; text-decoration: none; transition: all 0.3s linear; }
	a:hover{ color: #20b4ee; letter-spacing: 1px; }

	.parallax > use { animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite; }
	.parallax > use:nth-child(1) { animation-delay: -2s; animation-duration: 6s; }
	.parallax > use:nth-child(2) { animation-delay: -3s; animation-duration: 9s; }
	.parallax > use:nth-child(3) { animation-delay: -4s; animation-duration: 11s; }
	.parallax > use:nth-child(4) { animation-delay: -5s; animation-duration: 14s; }
	@keyframes move-forever { 0% { transform: translate3d(-90px, 0, 0); } 100% { transform: translate3d(85px, 0, 0); } }

	@media (max-width: 400px){
		.leftLeft{ display: none; }
		.rightRight{ display: none; }
		.left{ display: none; }
		.websites{ display: none; }
		.bottom{ background-color: #253b55; width: 100%; height: fit-content; color: #dcdcdc; }
		.main{ width: 90%; margin: 0 auto; padding-bottom: 14px; }
		.right{ font-size: 14px; text-align: center; }
		.logoImgCon{ width: 180px; margin: 0 auto;  border-bottom: 1px solid #5a5a5a; }
		.logoImg{ height: 40px; width: 132px; padding-bottom: 12px; margin-top: 22px; }
		.qrImg{ height: 146px; width: 146px; margin-top: 16px; }
		.copy{ font-size: 12px; margin: 0 auto; width: 70%; text-align: center; border-top: 1px solid #5a5a5a; padding: 16px 0; }
		.waves { position: relative; width: 100%; height: 18px; margin-bottom: -7px; min-height: 18px; max-height: 22px; }
	}
	@media (min-width: 401px) and (max-width: 746px){
		.left{ display: none; }
		.right{ display: none; }
		.bottom{ background-color: #253b55; width: 100%; height: fit-content; color: #dcdcdc; }
		.main{ width: 80%; margin: 0 auto; padding-bottom: 18px; display: flex; flex-wrap: nowrap; justify-content: space-between; }
		.leftLeft{ display: block; font-size: 12px; width: 60%; padding: 28px 18px 0 0; }
		.leftLeftItem{ margin-top: 12px; }
		.logoImgCon{ width: 150px;  border-bottom: 1px solid #5a5a5a; }
		.logoImg{ height: 42px; width: 150px; padding-bottom: 12px; }
		.rightRight{}
		.qrImg{ height: 160px; width: 160px; margin-top: 26px; }
		.copy{ font-size: 14px; margin: 0 auto; width: 80%; text-align: center; border-top: 1px solid #5a5a5a; padding: 20px 0; }
		.waves { position: relative; width: 100%; height: 22px; margin-bottom: -7px; min-height: 22px; max-height: 28px; }
	}
	@media (min-width: 747px) and (max-width: 1000px){
		.left{ display: none; }
		.right{ display: none; }
		.bottom{ background-color: #253b55; width: 100%; height: fit-content; color: #dcdcdc; }
		.main{ width: 80%; margin: 0 auto; padding-bottom: 26px; display: flex; flex-wrap: nowrap; justify-content: space-between; }
		.leftLeft{ display: block; font-size: 14px; width: 60%; padding: 26px 18px 0 0; }
		.leftLeftItem{ margin-top: 15px; }
		.logoImgCon{ width: 150px;  border-bottom: 1px solid #5a5a5a; }
		.logoImg{ height: 42px; width: 150px; padding-bottom: 12px; }
		.rightRight{}
		.qrImg{ height: 160px; width: 160px; margin-top: 26px; }
		.copy{ font-size: 14px; margin: 0 auto; width: 80%; text-align: center; border-top: 1px solid #5a5a5a; padding: 20px 0; }
		.waves { position: relative; width: 100%; height: 30px; margin-bottom: -7px; min-height: 30px; max-height: 40px; }
	}
	@media (min-width: 1001px){
		.leftLeft{ display: none; }
		.rightRight{ display: none; }
		.bottom{ background-color: #253b55; width: 100%; height: fit-content; color: #dcdcdc; }
		.main{ display: flex; justify-content: space-between; width: 80%; margin: 0 auto; padding-bottom: 32px; }
		.left{ padding-top: 28px; }
		.tit{ color: #ffffff; font-size: 16px; margin-top: 30px; }
		.linkCon{ font-size: 14px; margin-top: 10px; }
		.link{ margin-right: 20px; }
		.right{ font-size: 14px; text-align: center; }
		.logoImg{ height: 60px; width: 208px; border-bottom: 1px solid #6d6d6d; padding-bottom: 18px; margin-top: 38px; }
		.qrImg{ height: 160px; width: 160px; margin-top: 18px; }
		.websites{ margin-top: 12px; }
		.copy{ font-size: 14px; margin: 0 auto; width: 82%; text-align: center; border-top: 1px solid #5a5a5a; padding: 26px 0; }
		.waves { position: relative; width: 100%; height: 38px; margin-bottom: -7px; min-height: 38px; max-height: 42px; }
	}
</style>